export default (state = {
    confirmMobile:false,
    updateMobile:false,
    confirmEmail:false

}, action) => {
    switch (action.type) {
        case 'UI_REQUIRE_MOBILE_CONFIRM' :
            return {
                ...state,
                confirmMobile: action.status
            };
        case 'UI_REQUIRE_MOBILE_UPDATE' :
            return {
                ...state,
                updateMobile: action.status
            };
        case 'UI_REQUIRE_EMAIL_CONFIRM' :
            return {
                ...state,
                confirmEmail: action.status
            };
        default:
            return state;
    }
};
